<template>

  <div
    class="my-editor richText"
    :id="componentId"
  >
    <div>
      <!-- <Button
        @click="HTMLFlag = true"
        class="preview"
      >预览</Button> -->
    </div>
    <textarea
      ref="textarea"
      :key="index"
      v-model="currentValue"
      style="display: none;"
    ></textarea>
  </div>
</template>

<script>
import UploadAdapter from "./UploadAdapter";
// import oss from './aliOss'

var CKEditor = null;
if (process.client) {
  CKEditor = window.ClassicEditor;
}
/**
 * 富文本编辑器
 *
 */
const Toolbars = [
  "heading",
  "|",
  "preview",
  "|",
  "bold",
  "italic",
  "link",
  "bulletedList",
  "numberedList",
  "|",
  "indent",
  "outdent",
  "|",
  "imageUpload",
  "blockQuote",
  "insertTable",
  "undo",
  "redo",
  "alignment",
  "fontSize",
  "fontColor",
  "fontBackgroundColor",
  "fontFamily",
  "highlight",
  "horizontalLine",
  "strikethrough",
  "underline",
  "exportPdf",
];

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    valueMutil: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "预览",
    },
    toolbar: {
      type: [String, Array],
      default: "all",
      validator(val) {
        return Array.isArray(val) || ["simple", "classic", "all"].includes(val);
      },
    },
    // ckeditor5 配置
    config: {
      type: Object,
      default() {
        return {
          language: "zh-cn",
          fontSize: {
            options: [
              5,
              5.5,
              6.5,
              7.5,
              8,
              9,
              10,
              10.5,
              11,
              12,
              13,
              14,
              "default",
              16,
              17,
              18,
              19,
              20,
              21,
              26,
              28,
              36,
              48,
              56,
            ],
          },
          image: {
            resizeUnit: "px",
            styles: ["alignLeft", "alignCenter", "alignRight"],
            toolbar: [
              "imageTextAlternative",
              "|",
              "imageStyle:alignLeft",
              "imageStyle:alignCenter",
              "imageStyle:alignRight",
            ],
          },
          table: {
            contentToolbar: [
              "tableColumn",
              "tableRow",
              "mergeTableCells",
              "tableCellProperties",
              "tableProperties",
            ],
          },
          heading: {},
          licenseKey: "",
          fontFamily: {
            options: [
              "default",
              "Ubuntu, Arial, sans-serif",
              "Ubuntu Mono, Courier New, Courier, monospace",
              "宋体,SimSun",
              "新宋体,NSimSun",
              "仿宋_GB2312,FangSong_GB2312",
              "楷体_GB2312,KaiTi_GB2312",
              "黑体,SimHei",
              "微软雅黑,Microsoft YaHei",
              "隶书,LiSu",
              "幼园,YouYuan",
              "华文细黑,STXihei",
              "细明体,MingLiU",
              "新细明体,PMingLiU",
            ],
          },
        };
      },
    },
    height: {
      type: Number,
    },
    readonly: Boolean,
    disabled: Boolean,
  },
  data() {
    this.ckeditor = null;
    this.styleElement = null;
    return {
      currentValue: null,
      index: 0,
      HTMLFlag: false,
    };
  },
  computed: {
    ckeditorConfig() {
      return {
        toolbar: Toolbars,
        ...this.config,
      };
    },
    componentId() {
      return `my-editor-${this._uid}`;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.setData(val);
        // this.currentValue = val;
      },
    },
    valueMutil: {
      immediate: true,
      handler(val) {
        console.log('valueMutil')
        this.setData1(val);

      },
    },
    currentValue(val) {
      this.$emit("input", val);
      /**
       * 内容变化时触发
       * @event on-change
       * @param {string} val 新内容
       */
      this.$emit("change", val);
    },
    height: {
      immediate: true,
      handler(val) {
        val && this.setStyle(val);
      },
    },
    readonly(val) {
      if (this.ckeditor) {
        this.ckeditor.isReadOnly = val;
      }
    },
    disabled(val) {
      if (this.ckeditor) {
        this.ckeditor.isReadOnly = val;
      }
    },
  },
  methods: {
    init() {
      CKEditor.create(this.$refs.textarea, this.ckeditorConfig)
        .then((editor) => {
          this.ckeditor = editor;
          this.ckeditor.plugins.get("FileRepository").createUploadAdapter = (
            loader
          ) => {
            return new UploadAdapter(loader, this.upload);
          };
          this.ckeditor.isReadOnly = this.readonly || this.disabled;
          this.bindEvents(editor);
        })
        .catch((e) => {
          console.error("init CKEditor error", e);
        });
    },
    upload(loader) {
      return new Promise((resolve, reject) => {
        loader.file.then((file) => {
          this.$message.success("上传文件中！");
          const param = new FormData();
          if (file.size > 30 * 1024 * 1024) {
            this.$Message.warning("附件大小不能超过30M");
            reject();
          }
          param.append("file", file);
          this.$store.dispatch("companyProfile/upload", param).then((res) => {
            this.$message.success("上传文件成功！");
            resolve({
              default: res,
            });
          });
        });
      });
    },
    bindEvents(editor) {
      editor.model.document.on("change:data", () => {
        this.currentValue = this.getData();
      });
      editor.editing.view.document.on("focus", (evt) => {
        this.$emit("focus", evt, editor);
      });

      editor.editing.view.document.on("blur", (evt) => {
        this.$emit("blur", evt, editor);
      });
    },
    /**
     * 获取编辑器内容
     * @function getData
     * @return {*}
     */
    getData() {
      if (this.ckeditor) {
        return this.ckeditor.getData();
      }
      return null;
    },
    /**
     * 设置编辑器内容
     * @function setData
     * @param {string} val 文本
     */
    setData(val) {
      this.currentValue = val;
      if (val) {
        try {
          if (!this.getData()) {
            this.ckeditor && this.ckeditor.setData(val);
          }
        } catch (e) {}
      } else {
        this.ckeditor && this.ckeditor.setData("");
      }
    },
    setData1(val) {
      this.currentValue = val;
      if (val) {
        try {
          // if (!this.getData()) {
            this.ckeditor && this.ckeditor.setData(val);
          // }
        } catch (e) {}
      } else {
        this.ckeditor && this.ckeditor.setData("");
      }
    },
    setStyle(height) {
      // 由于 ckeditor 没有参数和接口调整编辑器的高度，这里采用在页面加载css来实现设置制定高度
      if (!this.styleElement) {
        this.styleElement = document.createElement("style");
        document.getElementsByTagName("head")[0].appendChild(this.styleElement);
      }
      this.styleElement.innerText = `#${this.componentId} .ck-content {height: ${height}px; }`;
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // 销毁样式元素
    if (this.styleElement) {
      this.styleElement.parentNode.removeChild(this.styleElement);
    }
    // 销毁 ckeditor
    this.ckeditor.setData("");
    this.ckeditor && this.ckeditor.destroy();
    this.ckeditor = null;
  },
};
</script>
<style lang="less">
.richText{
  .preview {
 position: relative;
    left: -46px;
    top: 40px;
    color: #333;
    background-color: #fcfcfc;
    width: 47px;
    height: 40px;
    border: 1px solid #d6d6d6;
    padding-left: 10px;
    border-radius: 0;
}
}

.HTML-Container {
  .ivu-modal-body {
    overflow: auto;
    line-height: 30px;
    .image {
      max-width: 1200px;
    }
    img {
      max-width: 1200px;
    }

    .image-style-align-center {
      text-align: center;
    }
  }
}
</style>